import { connect } from 'react-redux';
import { googleAuthRegisterThunk } from 'src/store/Auth/actions';
import { default as GoogleAuthRoot } from './GoogleAuth';

const mapStateToProps = ({ auth }) => ({
  loading: auth.loading,
  error: auth.error,
  errorReason: auth.reason,
});

const mapDispathToProps = {
  googleAuthRegisterThunk,
};

export const GoogleAuth = connect(mapStateToProps, mapDispathToProps)(GoogleAuthRoot);